export default __webpack_public_path__ + "static/media/photogallery-08.6babb948.webp";